import { branch, compose, renderNothing, withProps } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';
import get from 'lodash/get';

import {
  canEditNotJoinedPatient,
  isLoggedUserSelector,
  targetUserSelector,
  selectShowOwnProviderProfile,
} from '../../../redux/context/selectors';
import { actions as editUserActions } from '../../../redux/profiles/edit-user';
import {
  selectUsStates,
  selectGenderTypes,
  selectLanguageTypes,
  selectMaritalStatus,
  selectNameSuffixesList,
  selectCountryOptions,
  selectVeteranStatusesList,
  selectEducationLevelsList,
  selectCitizinship,
} from '../../../redux/data/selectors';
import { actions as editPatientActions } from '../../../redux/profiles/edit-patient';
import {
  selectEditedUserErrors,
  selectEditedUserSucceed,
  selectProfileEditable,
} from '../../../redux/profiles/selectors';
import styles from '../index.styl';

const mapStateToProps = state => ({
  profile: targetUserSelector(state),
  profileErrors: selectEditedUserErrors(state),
  rawGenderList: selectGenderTypes(state),
  languageList: selectLanguageTypes(state),
  nameSuffixList: selectNameSuffixesList(state),
  rawMaritalStatusList: selectMaritalStatus(state),
  statesList: selectUsStates(state),
  canEdit: isLoggedUserSelector(state),
  canEditPatient: canEditNotJoinedPatient(state),
  profileEditable: selectProfileEditable(state),
  showOwnProviderProfile: selectShowOwnProviderProfile(state),
  countryList: selectCountryOptions(state),
  isSucceedUpdate: selectEditedUserSucceed(state),
  veteranStatusesList: selectVeteranStatusesList(state),
  educationLevelsList: selectEducationLevelsList(state),
  citizenship: selectCitizinship(state),
});

const mapDispatchToProps = {
  saveUser: editUserActions.send,
  savePatient: editPatientActions.send,
};
export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(({ profileErrors }) => {
    return { errors: get(profileErrors, 'meta.validationErrors') };
  }),
  branch(
    ({ showOwnProviderProfile }) => !showOwnProviderProfile,
    renderNothing,
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/ProviderProfile/enhance.js